var storefrontApp = angular.module('storefrontApp');
storefrontApp.controller('learningCenterController', [
    '$scope', 'learningCenterService', '$sce', 'loaderService', 'randomService', '$location', "urlService", "$q", "customerReviewService", "elasticService", "modalService",
    function (
        $scope, learningCenterService, $sce, loaderService, randomService, location, urlService, $q, customerReviewService, elasticService, modalService
    ) {
        $scope.customerShowcaseQuickView = {
            currentReview: null,
            elasticProductInfo: null,
            individualRatingCountArray: [],
            searchCriteria: {
                categoryIds: null,
                pageNumber: 1,
                pageSize: 4,
                productDefinitions: null,
                productId: null,
                ratings: null,
                searchPhrase: null,
                sort: null,
                vendors: null,
                years: null,
            },
            searchResults: [],
            totalCount: 0,
            totalPages: 0,
            totalIndividualRatingCount: 0,
        };

        $scope.initialize = function () {
            GetProjects();
            GetLookbooks();
            GetRandomReviews();
            GetFeaturedDynamicContent();
            GetEmbroidererPickDynamicContent();
            GetBannerDynamicContent();
        }

        function GetProjects() {
            learningCenterService.getProjects(4).then(function (response) {
                $scope.projects = response.data;
            })
        }

        function GetLookbooks() {
            $scope.lookBooksCount = (angular.isDefined(window.__env.homepageKeys) && window.__env.homepageKeys.lookBooksCount > 0) ? window.__env.homepageKeys.lookBooksCount : 5;
            learningCenterService.getLookbooks($scope.lookBooksCount).then(
                function (response) {
                    $scope.lookbooks = randomService.getRandomItemsfromListArray(
                        response.data, 2
                    );
                }
            );
        }

        function GetRandomReviews() {
            learningCenterService.getRandomReviews(4).then(function (response) {
                $scope.reviews = response.data;
            })
        }

        function GetFeaturedDynamicContent() {
            learningCenterService.getDynamicContentBySectionName("featured").then(function (response) {
                var temp_featured_superheader = response.data.filter(function (x) { return x.sectionValue.toLowerCase() == "superheader"; });
                var temp_featured_header = response.data.filter(function (x) { return x.sectionValue.toLowerCase() == "header"; });
                var temp_featured_image = response.data.filter(function (x) { return x.sectionValue.toLowerCase() == "image1"; });
                var temp_featured_title = response.data.filter(function (x) { return x.sectionValue.toLowerCase() == "title"; });
                var temp_featured_content = response.data.filter(function (x) { return x.sectionValue.toLowerCase() == "content"; });
                var temp_featured_button = response.data.filter(function (x) { return x.sectionValue.toLowerCase() == "button"; });

                $scope.featured_superheader = temp_featured_superheader != null && temp_featured_superheader.length > 0 ? temp_featured_superheader[0] : null;
                $scope.featured_header = temp_featured_header != null && temp_featured_header.length > 0 ? temp_featured_header[0] : null;
                $scope.featured_image = temp_featured_image != null && temp_featured_image.length > 0 ? temp_featured_image[0] : null;
                $scope.featured_title = temp_featured_title != null && temp_featured_title.length > 0 ? temp_featured_title[0] : null;
                $scope.featured_content = temp_featured_content != null && temp_featured_content.length > 0 ? temp_featured_content[0] : null;
                $scope.featured_button = temp_featured_button != null && temp_featured_button.length > 0 ? temp_featured_button[0] : null;
            })
        }

        function GetEmbroidererPickDynamicContent() {
            learningCenterService.getDynamicContentBySectionName("embroidererpick").then(function (response) {
                var temp_embroidererpick_header = response.data.filter(function (x) { return x.sectionValue.toLowerCase() == "header"; });
                var temp_embroidererpick_linktext = response.data.filter(function (x) { return x.sectionValue.toLowerCase() == "linktext"; });
                var temp_embroidererpick_image1 = response.data.filter(function (x) { return x.sectionValue.toLowerCase() == "image1"; });
                var temp_embroidererpick_image2 = response.data.filter(function (x) { return x.sectionValue.toLowerCase() == "image2"; });
                var temp_embroidererpick_image3 = response.data.filter(function (x) { return x.sectionValue.toLowerCase() == "image3"; });
                var temp_embroidererpick_image4 = response.data.filter(function (x) { return x.sectionValue.toLowerCase() == "image4"; });
                var temp_embroidererpick_image5 = response.data.filter(function (x) { return x.sectionValue.toLowerCase() == "image5"; });
                var temp_embroidererpick_image6 = response.data.filter(function (x) { return x.sectionValue.toLowerCase() == "image6"; });
                var temp_embroidererpick_image7 = response.data.filter(function (x) { return x.sectionValue.toLowerCase() == "image7"; });

                $scope.embroidererpick_header = temp_embroidererpick_header != null && temp_embroidererpick_header.length > 0 ? temp_embroidererpick_header[0] : null;
                $scope.embroidererpick_linktext = temp_embroidererpick_linktext != null && temp_embroidererpick_linktext.length > 0 ? temp_embroidererpick_linktext[0] : null;
                $scope.embroidererpick_image1 = temp_embroidererpick_image1 != null && temp_embroidererpick_image1.length > 0 ? temp_embroidererpick_image1[0] : null;
                $scope.embroidererpick_image2 = temp_embroidererpick_image2 != null && temp_embroidererpick_image2.length > 0 ? temp_embroidererpick_image2[0] : null;
                $scope.embroidererpick_image3 = temp_embroidererpick_image3 != null && temp_embroidererpick_image3.length > 0 ? temp_embroidererpick_image3[0] : null;
                $scope.embroidererpick_image4 = temp_embroidererpick_image4 != null && temp_embroidererpick_image4.length > 0 ? temp_embroidererpick_image4[0] : null;
                $scope.embroidererpick_image5 = temp_embroidererpick_image5 != null && temp_embroidererpick_image5.length > 0 ? temp_embroidererpick_image5[0] : null;
                $scope.embroidererpick_image6 = temp_embroidererpick_image6 != null && temp_embroidererpick_image6.length > 0 ? temp_embroidererpick_image6[0] : null;
                $scope.embroidererpick_image7 = temp_embroidererpick_image7 != null && temp_embroidererpick_image7.length > 0 ? temp_embroidererpick_image7[0] : null;
            })
        }

        function GetBannerDynamicContent() {
            learningCenterService.getDynamicContentBySectionName("banner").then(function (response) {
                var temp_banner_image1 = response.data.filter(function (x) { return x.sectionValue.toLowerCase() == "image1"; });
                var temp_banner_image2 = response.data.filter(function (x) { return x.sectionValue.toLowerCase() == "image2"; });
                var temp_banner_image3 = response.data.filter(function (x) { return x.sectionValue.toLowerCase() == "image3"; });
                var temp_banner_image4 = response.data.filter(function (x) { return x.sectionValue.toLowerCase() == "image4"; });
                var temp_banner_image5 = response.data.filter(function (x) { return x.sectionValue.toLowerCase() == "image5"; });

                $scope.banner_image1 = temp_banner_image1 != null && temp_banner_image1.length > 0 ? temp_banner_image1[0] : null;
                $scope.banner_image2 = temp_banner_image2 != null && temp_banner_image2.length > 0 ? temp_banner_image2[0] : null;
                $scope.banner_image3 = temp_banner_image3 != null && temp_banner_image3.length > 0 ? temp_banner_image3[0] : null;
                $scope.banner_image4 = temp_banner_image4 != null && temp_banner_image4.length > 0 ? temp_banner_image4[0] : null;
                $scope.banner_image5 = temp_banner_image5 != null && temp_banner_image5.length > 0 ? temp_banner_image5[0] : null;
            })
        }

        $scope.getProjectUrl = function (imageUrl) {
            if (imageUrl != null) {
                return urlService.getImageUrl({
                    "definitionName": "project_tutorial",
                    "imgName": imageUrl
                });
            }
        }

        $scope.getLookbookPageImg = function (id, pg) {
            return urlService.getImageUrl(
                {
                    "definitionName": "lookbook",
                    "lookbookId": id,
                    "pageNumber": pg
                }
            );
        }

        $scope.setReviewRating = function (id, rating) {
            for (var i = 1; i <= rating; i++) {
                document.getElementById(i.toString() + id.toString()).classList.add("active-color")
            }
        }

        $scope.navigateToLink = function (link) {
            if (link != null) {
                window.location = link;
            }
        }

        $scope.navigateToLoookbook = function (lb) {
            window.location.href = "/learning-center/lookbooks?id=" + lb.lookbookId;
        }

        $scope.navigateToProject = function (project) {
            var title = project.title
                .replace(/\s|\/|\?/g, "-")
                .replace(/&|\+/g, "")
                .replace(/[^\w-]*/g, "")
                .replace(/^[-]/g, "")
                .replace(/[-]$/g, "")
                .toLowerCase();
            window.location.href = "/how-to-embroider/project/" + project.projectId + "/" + title;
        }

        $scope.navigateToAuthorProjects = function (project) {
            var url = urlService.getAuthorProjectsUrl(
                project.fK_AuthorId, project.authorName
            )
            window.location.href = url;
        }

        $scope.closeCustomerShowcaseQuickView = function () {
            modalService.close("customerShowcaseQuickViewModal");
        };

        $scope.initializeCustomerShowcaseQuickView = function (productId) {
            $scope.$broadcast("InitializeCustomerShowcaseQuickView", productId);
        }

        $scope.initialize();

    }])
